module.exports = __webpack_public_path__ + "static/images/banner.4641acf.jpg";